/***********************  ADD PROJECT ****************************************/

import { ASSIGN_LEAD,ASSIGN_LEAD_ERR} from '../../actionTypes/leadsType'
import { assignLeadApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'


export const assignLead = payload => async dispatch => {
    try {
        let results = await axios.post(`${assignLeadApi}`, payload, await accessToken())
         console.log("Assign LEAD", results)
        let data = results && results.data
        dispatch({
            type: ASSIGN_LEAD,
            payload: data || [],
        });
    } catch (error) {
        dispatch({
            type: ASSIGN_LEAD_ERR,
            payload: error.response
        });
    }
}

/***********************  ADD PROJECT ****************************************/